import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FAQSection } from "./sections/FAQSection";
import { GuidesSection } from "./sections/GuidesSection";
import { ContactSection } from "./sections/ContactSection";
import { SystemStatusSection } from "./sections/SystemStatusSection";
import { HelpSearch } from "./components/HelpSearch";
import { useToast } from "@/hooks/use-toast";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function HelpContent() {
  const [activeTab, setActiveTab] = useState("faq");
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/dashboard");
  };

  return (
    <div className="container mx-auto py-6 px-4 space-y-6">
      <div className="relative">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-0 top-0"
          onClick={handleClose}
          aria-label="Lukk hjelp og support"
        >
          <X className="h-5 w-5" />
        </Button>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Hjelp og Support</h1>
          <p className="text-muted-foreground">
            Finn svar på dine spørsmål eller kontakt oss for assistanse
          </p>
        </div>
      </div>

      <HelpSearch />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <TabsTrigger value="faq">Ofte stilte spørsmål</TabsTrigger>
          <TabsTrigger value="guides">Guider og opplæring</TabsTrigger>
          <TabsTrigger value="contact">Kontakt oss</TabsTrigger>
          <TabsTrigger value="status">Systemstatus</TabsTrigger>
        </TabsList>

        <TabsContent value="faq" className="space-y-4">
          <FAQSection />
        </TabsContent>

        <TabsContent value="guides" className="space-y-4">
          <GuidesSection />
        </TabsContent>

        <TabsContent value="contact" className="space-y-4">
          <ContactSection />
        </TabsContent>

        <TabsContent value="status" className="space-y-4">
          <SystemStatusSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}